import configureStore from './state/configureStore';

export default configureStore({});
